// Removing sensitive information from the headers before logging
export const filterSensitiveHeaders = (headers: any) => {
  const sensitiveHeaders = new Set(['authorization', 'x-aaduserticket', 'x-xsrf-token', 'x-xsrf-cookie']);
  return headers
    ? Object.keys(headers).reduce((acc: any, key: any) => {
        if (!sensitiveHeaders.has(key.toLowerCase())) {
          acc[key] = headers[key];
        }
        return acc;
      }, {})
    : {};
};
